import { useMemo } from "react";
import useQuotaUsage from "../../quota-usage/hooks/useQuotaUsage";

export const RLCS_FILE_PRODUCT_CODE = "TCA-0207";
export const RLCS_URL_PRODUCT_CODE = "TCA-0207-URL";

const useRlcsQuotaLimitInfo = (
  productCode: string = RLCS_FILE_PRODUCT_CODE
) => {
  const {
    usage: { daily_limits }
  } = useQuotaUsage();

  const rlcsUsageData = daily_limits?.find(
    item => item.product_code === productCode
  );

  const { isHighUsage, isMaxedOut, displayPercent } = useMemo(() => {
    const { usage = 0, limit = 0 } = rlcsUsageData ?? {};

    if (limit === 0)
      return { isHighUsage: false, isMaxedOut: false, displayPercent: "0%" };

    const ratio = usage / limit;

    return {
      isHighUsage: ratio >= 0.8 && ratio < 1,
      isMaxedOut: ratio >= 1,
      displayPercent: `${Math.round(ratio * 100)}%`
    };
  }, [rlcsUsageData?.usage, rlcsUsageData?.limit]);

  return {
    isHighUsage,
    isMaxedOut,
    displayPercent,
    showLimitInfo: isHighUsage || isMaxedOut
  };
};

export default useRlcsQuotaLimitInfo;
